import PropTypes from 'prop-types'
import { useMemo, useState } from 'react'
import {
  AdHeadText,
  AdSublink,
  AdThumb,
  AssetClassNames,
  Ktalk,
  LayerMultiThumbnail,
  ListPay,
} from 'features/creative/preview/PreviewParts'
import classNames from 'classnames'
import {
  getLandingUrlState,
  stripKeywordTag,
} from 'features/creative/creativeUtil'
import { Assets } from 'features/Codes'
import SiteUrlPropTypes from '../../channel/SiteUrlPropTypes'

const MixedBasicPreview = ({ types = [], creative, isMobileView, siteUrl }) => {
  const { individual, mobileUrl, pcUrl } = getLandingUrlState({
    individualSettingYn: siteUrl?.individualSettingYn,
    mobileLandingUrl: siteUrl?.mobileUrl,
    pcLandingUrl: siteUrl?.pcUrl,
  })
  const viewUrl = useMemo(() => {
    if (individual) {
      if (isMobileView) {
        return mobileUrl || pcUrl || 'http://m.daum.net'
      } else {
        return pcUrl || mobileUrl || 'http://www.daum.net'
      }
    } else {
      return pcUrl || mobileUrl || 'http://www.daum.net'
    }
  }, [isMobileView, individual, pcUrl, mobileUrl])

  const getAssetData = type =>
    creative?.assets.find(a => a.type.name === type.name)?.data
  const [isMouseOver, setMouseOver] = useState(false)

  if (types.length === 0) {
    return (
      <div className="material_default">
        <div className="inner_cont">
          <strong className="ad_subject">
            {stripKeywordTag(creative.title) || '제목'}
          </strong>
          <div className="ad_link">
            {isMobileView && <span className="ico_ad">광고</span>}
            <span className="txt_link">{viewUrl}</span>
          </div>
          <div className="ad_info">
            <span
              className={classNames('ad_desc', {
                ad_hospital: creative.licenseNumber,
              })}>
              {stripKeywordTag(creative.description) || '설명문구'}
            </span>
            {creative.licenseNumber && (
              <span className="ad_set">{creative.licenseNumber}</span>
            )}
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="material_mix">
      <em className="mix_type">
        {types.map(t => AssetClassNames[t].title).join(' + ')}
      </em>
      <div
        className={classNames(
          'material_default',
          ...types.map(t => AssetClassNames[t].className)
        )}>
        <div className="inner_cont">
          <strong className="ad_subject">
            {stripKeywordTag(creative.title) || '제목'}
          </strong>
          {types.includes(Assets.SUBJECT.name) && isMobileView && (
            <AdHeadText {...getAssetData(Assets.SUBJECT)} />
          )}
          <div className="ad_link">
            {isMobileView && <span className="ico_ad">광고</span>}
            <span className="txt_link">{viewUrl}</span>
          </div>
          {types.includes(Assets.SUBJECT.name) && !isMobileView && (
            <AdHeadText {...getAssetData(Assets.SUBJECT)} />
          )}
          {types.includes(Assets.ADDITIONAL_TITLE.name) && (
            <p className="ad_subtxt">
              {getAssetData(Assets.ADDITIONAL_TITLE)?.text || '추가제목'}
            </p>
          )}
          <div className="ad_info">
            <span
              className={classNames('ad_desc', {
                ad_hospital: creative.licenseNumber,
              })}>
              {stripKeywordTag(creative.description) || '설명문구'}
            </span>
            {creative.licenseNumber && (
              <span className="ad_set">{creative.licenseNumber}</span>
            )}
          </div>
          {types.includes(Assets.CALCULATE.name) && (
            <div className="ad_btn">
              <span className="ico_btn ico_sum">계산하기</span>
            </div>
          )}
          {types.includes(Assets.PHONE_NUMBER.name) && (
            <div className="ad_btn">
              <span className="ico_btn ico_tel">전화하기</span>
            </div>
          )}
          {types.includes(Assets.TALK_CHANNEL.name) && <Ktalk />}
          {types.includes(Assets.PRICE_TABLE.name) && !isMobileView && (
            <ListPay {...getAssetData(Assets.PRICE_TABLE)} />
          )}
          {types.includes(Assets.ADDITIONAL_LINK.name) && !isMobileView && (
            <AdSublink {...getAssetData(Assets.ADDITIONAL_LINK)} />
          )}
        </div>
        {types.includes(Assets.MULTI_THUMBNAIL.name) && !isMobileView && (
          <AdThumb
            url={getAssetData(Assets.MULTI_THUMBNAIL)?.images[0].url}
            setMouseOver={setMouseOver}
            width={64}
            thumbInfo
          />
        )}
        {types.includes(Assets.THUMBNAIL.name) && (
          <AdThumb
            url={getAssetData(Assets.THUMBNAIL)?.image.url}
            width={isMobileView ? 90 : 64}
          />
        )}
        {isMobileView &&
          (types.includes(Assets.PRICE_TABLE.name) ||
            types.includes(Assets.ADDITIONAL_LINK.name)) && (
            <div className="inner_cont">
              {types.includes(Assets.PRICE_TABLE.name) && (
                <ListPay {...getAssetData(Assets.PRICE_TABLE)} />
              )}
              {types.includes(Assets.ADDITIONAL_LINK.name) && (
                <AdSublink {...getAssetData(Assets.ADDITIONAL_LINK)} />
              )}
            </div>
          )}
      </div>
      {types.includes(Assets.MULTI_THUMBNAIL.name) && !isMobileView && (
        <LayerMultiThumbnail
          thumbnails={getAssetData(Assets.MULTI_THUMBNAIL)?.images}
          isMouseOver={isMouseOver}
          setMouseOver={setMouseOver}
        />
      )}
    </div>
  )
}

export default MixedBasicPreview

MixedBasicPreview.propTypes = {
  creative: PropTypes.object.isRequired,
  siteUrl: SiteUrlPropTypes,
  types: PropTypes.arrayOf(PropTypes.string),
  isMobileView: PropTypes.bool,
}
